









































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {EOS卸型} from '@/type/wholesale/wholesale';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';

@Component({
  components: {
    NormalDialog,
  },
})

export default class ListEosWholesales extends Vue {

  private EOS卸一覧: EOS卸型[] = [];
  private 選択EOS卸: EOS卸型 | null = null;

  // NOTE: Prop
  @Prop({default: false})
  private modal!: boolean;

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal === true) {
      this.$modal.show('EOS卸マスタ画面');
    }
  }

  @Emit('select-wholesale')
  private selectWholesale(): EOS卸型 | null {
    this.$modal.hide('EOS卸マスタ画面');
    return this.選択EOS卸;
  }

  @Emit('close-form')
  private closeForm(): void {
    this.選択EOS卸 = null;
    this.$modal.hide('EOS卸マスタ画面');
  }

  private created(): void {
    this.一覧を取得する();
  }

  private async 一覧を取得する(): Promise<void> {
    this.EOS卸一覧 = await api.EOS卸一覧を取得する();
  }

  private choice(EOS卸: EOS卸型): void {
    this.選択EOS卸 = EOS卸;
  }
}
